<template>
  <div class="blogs-content">
    <div class="blogs">
      <div class="blogs-bg">
        <div id="breadcrumbs">
          <nav class="breadcrumbs">
            <span class="breadcrumbs-item">
              <a href="/">
                <span>{{ $t('new.home') }}</span>
              </a>
            </span>
            <span class="breadcrumb-divider" aria-hidden="true">/</span>
            <span class="breadcrumbs-item">
              <router-link to="/blogs" style="text-decoration: none;">
                <span>{{ $t('new.blogAll') }}</span>
              </router-link>
            </span>
            <span class="breadcrumb-divider" aria-hidden="true">/</span>
            <span class="breadcrumbs-item">
              <span>{{ $t('new.blogdetail') }}</span>
            </span>
          </nav>
        </div>
        <div class="blogs-bg-img">
          <img src="@/assets/blogs/banner.png" alt="">
        </div>
        <!-- <div class="blogs-bg-breadcrumb">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">{{ $t('blogs.breadcrumb.title') }}</a></li>
                <li class="breadcrumb-item" @click="goBack">{{ $t('blogs.breadcrumb.activeTitle')}}</li>
                <li class="breadcrumb-item active" aria-current="page">{{ BreadcrumbName }}</li>
              </ol>
            </nav>
          </div> -->
        <div class="pc-fixed-icon" @click="openInquiryForm">
          <img src="@/assets/home/xinxi.png" alt="">
        </div>
      </div>
      <div class="blogs-cont">
        <div class="blogs-cont-item" v-loading="loading">
          <div class="blogs-cont-item-title">
            <strong>{{ list.title }}</strong>
          </div>
          <div class="blogs-cont-item-text">
            <p v-html="list.content" class="v-html-container"></p>
          </div>
          <!-- <div class="blogs-cont-item-img">
          <img :src="list.image" alt="">
        </div> -->
          <!-- <div class="blogs-cont-item-text">
          <p>{{ list.content }}</p>
        </div> -->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { bus } from '@/utils/bus'
import { getNewsDetail } from '@/api/komo'
export default {
  name: 'blogsDetail',
  // props: {
  //   id: {
  //     type: String,
  //     default: ''
  //   },
  //   chidList: {
  //     type: Object,
  //     default: () => ({})
  //   }
  // },
  data() {
    return {
      list: {},
      BreadcrumbName: '',
      detailId: '',
      loading: true
    };
  },
  created() {
    this.list = {};
    console.log('route', this.$route.params)

    // this.BreadcrumbName = this.$route.params.tabName;
    if (this.$route.params.type == 'enterprise') {
      this.BreadcrumbName = this.$t('blogs.tabs.Enterprise')
    } else if (this.$route.params.type == 'industry') {
      this.BreadcrumbName = this.$t('blogs.tabs.Industry')
    }
    console.log(this.BreadcrumbName)
    this.detailId = this.$route.params.id;
    this.getNewsDetailData(this.detailId)
  },
  watch: {
    '$route'(to, from) {
      console.log('watch', to)
      // 立即清理旧数据，避免显示旧内容
      this.list = {};
      this.BreadcrumbName = '';
      this.loading = true;
      // to.params不能是空对象
      if (to.params && typeof to.params === 'object' && Object.keys(to.params).length > 0) {
        if (to.params.type == 'enterprise') {
          this.BreadcrumbName = this.$t('blogs.tabs.Enterprise')
        } else if (to.params.type == 'industry') {
          this.BreadcrumbName = this.$t('blogs.tabs.Industry')
        }
        this.detailId = to.params.id;
        this.getNewsDetailData(this.detailId)
      }
    }
  },
  methods: {
    openInquiryForm() {
      bus.$emit('inquiry-form', true)
    },
    async getNewsDetailData(id) {
      try {
        // 在请求前重置数据
        this.list = {};

        const res = await getNewsDetail(id);
        // 添加检查确保组件仍然挂载
        if (res && res.data?.list) {
          this.list = res.data.list;
        } else {
          this.list = {};
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.list = {};
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push({
        path: '/blogs'
      })
      this.list = {};
    },
  },
  mounted() {
    // this.BreadcrumbName = this.chidList.tabName;
    // this.getNewsDetail(this.chidList.id);
    this.list = {};
  }
};
</script>

<style scoped lang="scss">
/* 样式部分 */
.blogs {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}

.blogs-bg {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2%;
}

.blogs-bg-img {
  width: 100%;
  height: 580px;
}

.blogs-bg-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blogs-bg-breadcrumb {
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}

.blogs-bg-breadcrumb .breadcrumb {
  margin: 0;
  font-size: 1.5rem;
}

.blogs-bg-breadcrumb .breadcrumb a {
  color: #959595;
  text-decoration: none;
}

.blogs-bg-breadcrumb .breadcrumb-item.active {
  font-weight: bold;
  color: #1E1E1E;
}

.blogs-bg-information {
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}

.blogs-bg-information img {
  width: 100%;
  height: 100%;
}

/* 内容 */
.blogs-cont {
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
}

.blogs-cont-item {
  width: 80%;
  height: 100%;
  margin: 0 auto;
}

.blogs-cont-item-title {
  font-size: 2vw;
  color: #1E1E1E;
  margin-bottom: 1%;
}

.blogs-cont-item-text {
  margin-bottom: 2%;
}

.blogs-cont-item-text p {
  font-size: 1vw;
  color: #959595;
  // line-height: 1.8vw;
}

.blogs-cont-item-img {
  width: 100%;
  height: 30vw;
  margin-bottom: 2%;
}

.blogs-cont-item-img img {
  width: 100%;
  height: 100%;
}

::v-deep .v-html-container p {
  display: flex;
  flex-direction: column;
}

::v-deep .v-html-container img {
  /* width: 100%;
  height: 100%;
  object-fit: contain; */
}


#breadcrumbs {
  margin: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 60px;
  padding-right: 60px;

  .breadcrumbs {
    font-size: 0;

    .breadcrumbs-item {
      margin-right: 10px;
      display: inline-block;
      font-size: 12px;

      a {
        color: var(--font-color);

        span {
          display: inline-block;
          padding-bottom: 0;
          font-family: var(--label-font-stack);
          font-weight: var(--label-font-weight);
          font-style: var(--label-font-style);
          text-transform: var(--label-font-case);
          letter-spacing: var(--label-spacing);
        }
      }
    }

    .breadcrumbs-item:not(:first-child) {
      margin-left: 10px;
    }

    .breadcrumb-divider {
      font-size: 12px;
    }
  }
}

@media only screen and (min-width: 768px) {
  .breadcrumbs a {
    background-color: transparent !important;
    background-image: linear-gradient(to top, currentColor 0, currentColor 0), linear-gradient(to top, transparent 0, transparent 0);
    background-repeat: no-repeat;
    background-position: left bottom, left bottom;
    background-size: 0 1px, 100% 1px;
    transition-property: background-size;
    transition-timing-function: ease;
    transition-duration: .25s;
  }

  .breadcrumbs a:hover {
    background-position: left bottom, left bottom;
    background-size: 100% 1px, 100% 1px;
  }
}
@media (max-width: 1200px){
.blogs-cont-item-title {
    font-size: 30px;
    font-family: var(--header-font-stack);
    // font-weight: 600;
  }
  ::v-deep .v-html-container p {
    // margin: 0 0 15px 0;
    font-size: var(--base-font-size);
    font-family: var(--label-font-stack);
  }
}
@media (max-width: 765px) {
  #breadcrumbs {
    padding-left: 10px;
    padding-right: 0px;
  }

  .blogs-cont-item {
    width: 90%;
  }

  .blogs-cont-item-title {
    font-size: 30px;
    font-family: var(--header-font-stack);
    // font-weight: 600;
  }

  ::v-deep .v-html-container p {
    // margin: 0 0 15px 0;
    font-size: var(--base-font-size);
    font-family: var(--label-font-stack);
  }

}

.blogs-content {
  padding: var(--nav-max-height) 0 0;
}

@media (max-width: 1115px) {
  .blogs-content {
    padding: var(--nav-1115-height) 0 0;
  }
}

@media (max-width: 990px) {
  .blogs-content {
    padding: var(--nav-990-height) 0 0;
  }
}
</style>